// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"next-arrow_nextButton__FJr_R","buttonContainer":"next-arrow_buttonContainer__sppDe"};